import { VStack, Box } from '@cad-arc';
import { UseFormReturn } from 'react-hook-form';
import { FormBody } from '../../forms/integrated-form-components/form-body';
import { ErrorBoundary, ErrorBoundaryBanner } from '../../monitoring/error-boundary';
import { SEARCH_FORM_FOOTER_HEIGHT_PX } from '../../search-windows/constants';
import { FR_EMERGENCY_BANNER_INCLUDED_HEIGHT, FR_HEADER_HEIGHT } from '../constants';
import { EnsuredQueryResult } from '../../unit-queues/components/get-unit-queue-filter-options';
import { useApplicationType } from '../../common/hooks/use-application-type';
import { useUnitEmergency } from '../../unit-emergency/use-unit-emergency';

interface SearchFormWrapperProps<T, Y> {
    query: EnsuredQueryResult<T>;
    form: UseFormReturn<Y>;
    resultsOrSavedShown: boolean;
    formBody: React.ReactElement;
    footer: React.ReactElement;
}

export function FormWrapper<T, Y>({
    query,
    form,
    resultsOrSavedShown,
    footer,
    formBody,
}: SearchFormWrapperProps<T, Y>) {
    const { isFirstResponder } = useApplicationType();
    const { filteredUnAckedUnitEmergencies } = useUnitEmergency();
    return (
        <ErrorBoundary
            name="SEARCH_WINDOW_FORM"
            fallback={({ resetError }) => (
                <ErrorBoundaryBanner
                    actions={[
                        {
                            children: 'Refresh page',
                            isLoading: query.isRefetching,
                            onClick: () => {
                                form.reset();
                                query.refetch().then(() => {
                                    resetError();
                                });
                            },
                        },
                    ]}
                />
            )}
            onError={() => query.refetch()}
            messageOverride="An error occurred"
        >
            <VStack
                h={`calc(100% - ${
                    filteredUnAckedUnitEmergencies.length > 0
                        ? FR_EMERGENCY_BANNER_INCLUDED_HEIGHT *
                          filteredUnAckedUnitEmergencies.length
                        : FR_HEADER_HEIGHT
                }px)`}
                w="100%"
                style={{ marginTop: 0, display: resultsOrSavedShown ? 'none' : 'flex' }}
                justifyContent="space-between"
            >
                <Box
                    h={`calc(100% - ${SEARCH_FORM_FOOTER_HEIGHT_PX}px)`}
                    w="100%"
                    padding={isFirstResponder ? '24px' : '24px 56px'}
                    overflowY={query.isInitialLoading ? 'hidden' : 'auto'}
                >
                    <FormBody>{formBody}</FormBody>
                </Box>
                {footer}
            </VStack>
        </ErrorBoundary>
    );
}
